import { isArray, mergeDeep } from '@config/utils';
import {
    getAcl,
    getUrl,
    getTools,
    getTool,
    getPanel,
    getPanels,
    getModule,
    getModuleName,
    getModules,
    getStateTool,
    getStateTools,
    isPanelVisible,
    isPanelActive,
    getConfigMap,
    getActionMap,
    getViewProjectionMap,
    getMapDefinitions,
    getGroupsMainMenu,
    getAction
} from '@/app/shared/utils/stateGetterUtils';
import {Fill, Stroke, Circle as CircleStyle, Style, Icon} from 'ol/style';

export default {
    loading: state => state.loading,
    locale: state => state.locale,
    localeCode: state => state.locale.code,
    localeAllowed: state => state.locale.localeAllowed ?? [],
    currentLocaleSelector: (state) => state.locale && state.locale.code || 'pt-PT',
    currentMessagesSelector: (state) => state.locale && state.locale.messages || {},
    applicationCode: state => state.data.global.applicationCode || state.data.global.code,
    moduleCode: state => state.data.global.code,
    moduleName: state => state.data.global.title || '',
    moduleDescription: state => state.data.global.description || '',
    moduleKeywords: state => state.data.global.keywords || '',
    moduleThemeColor: state => state.data.global.theme_color || '#7597ff',
    platformContactConfig: (state) => {
        return state.data.global.settings?.contact ?? {};
    },
    platformSocialNetworksConfig: (state) => {
        return state.data.global.settings?.social_networks ?? {};
    },
    customSettings: (state) => {
        return state?.config?.CUSTOM ?? {};// && env.CUSTOM.modules && env.CUSTOM.modules[idModule] ? env.CUSTOM.modules[idModule] : {};
    },
    getSettings: (state, getters) => (idModule, setting) => {
        const panels = getters.getPanel(idModule, setting);
        return panels ? panels.panel : {};
    },
    getMainMenu: (state, getters) => idModule => {
        const panels = getters.getPanels(idModule) || {};
        let _panels = panels;

        let dashboardPanel = panels.find(item => item.id == 'dashboard') ?? {};
        let defaultDashboardPanel = getters.getPanel(null, 'dashboard');
        let _dashboardPanel = null;
        if(defaultDashboardPanel) {
            _dashboardPanel = mergeDeep(defaultDashboardPanel, dashboardPanel);
            _panels = [..._panels, _dashboardPanel];
        }

        let keys = Object.keys(_panels).filter(k => _panels[k].menu);
        let items = [];
        keys.forEach((key) => {
            let panel = _panels[key];
            let menu = !isArray(panel.menu) ? [panel.menu] : panel.menu;
            menu.forEach(item => {
                items.push({
                    ...item,
                    ...{
                        active: item.active != undefined ? item.active : (panel.active == undefined ? true : panel.active),
                        auth: panel.acl ? panel.acl.view : null, key
                    }
                });
            });
        });
        return items;
    },
    getGroupsMainMenu: state => (idModule) => {
        return getGroupsMainMenu(idModule && state[idModule] ? state[idModule] : state);
    },
    getTools: state => (idModule) => {
        return getTools(idModule && state[idModule] ? state[idModule] : state);
    },
    getTool: state => (idModule, id) => {
        return getTool(idModule && state[idModule] ? state[idModule] : state, id);
    },
    getStateTools: (state) => (idModule) => {
        return getStateTools(idModule && state[idModule] ? state[idModule] : state);
    },
    getStateTool: (state) => (idModule, id) => {
        return getStateTool(idModule && state[idModule] ? state[idModule] : state, id);
    },
    getPanels: (state, getters) => (idModule) => {
        return getPanels(idModule && state[idModule] ? state[idModule] : state, idModule ? getters[`${idModule}/getTools`] : getters.getTools);
    },
    getPanel: (state, getters) => (idModule, id) => {
        return getPanel(idModule && state[idModule] ? state[idModule] : state, idModule ? getters[`${idModule}/getTools`] : getters.getTools, id);
    },
    isPanelActive: (state, getters) => (idModule, id) => {
        return isPanelActive(idModule ? getters[`${idModule}/getTools`] : getters.getTools, id);
    },
    isPanelVisible: (state, getters) => (idModule, id) => {
        return isPanelVisible(idModule ? getters[`${idModule}/getTools`] : getters.getTools, id);
    },
    getAcl: (state, getters) => (idModule, id) => {
        return getAcl(idModule && state[idModule] ? state[idModule] : state, idModule ? getters[`${idModule}/getTools`] : getters.getTools, id);
    },
    getUrl: (state, getters) => (idModule, id) => {
        return getUrl(idModule && state[idModule] ? state[idModule] : state, idModule ? getters[`${idModule}/getTools`] : getters.getTools, id);
    },
    getSearchBoxConfig: (state, getters) => (idModule) => {
        const id = 'navsearch';
        const panel = getters.getPanel(idModule, id);
        const tool = getters.getTool(idModule, id);
        return panel || tool?.panel || {};
    },
    getSearchBox: (state, getters) => (idModule) => {
        const cfg = getters.getSearchBoxConfig(idModule);
        return cfg?.search ?? {};
    },
    getModule: (state) => (idModule) => {
        return getModule(idModule && state[idModule] ? state[idModule] : state);
    },
    getModuleName: (state) => (idModule) => {
        return getModuleName(idModule && state[idModule] ? state[idModule] : state);
    },
    getModules: (state) => (idModule) => {
        return getModules(idModule && state[idModule] ? state[idModule] : state);
    },

    // FOOTER
    footerConfig: (state) => {
        return state.data.global.footer || {};
    },
    getSlugPageType: (state) => (type) => {
        if (state.data.global.pageType[type])
            return state.data.global.pageType[type];
        return '';
    },
    // NAVIGATION
    navigationRoute: (state) => {
        return state.data.global.navigation.route || {};
    },
    // BREADCRUMB
    breadcrumb: (state) => {
        return state.data.panels.breadcrumb || {};
    },
    // TOC
    tocSelectedSelector: (state) => (idModule) => {
        // return getters.getTool(idModule, 'layers').selected || null;
        return state.data.panels.toclayers.selected || null;
    },

    // IDENTIFY
    identifyPanel: (state) => {
        return state.data.panels.identify; //getters.getPanel(idModule, 'identify');
    },
    identifyLoadingSelector: (state, getters) => {
        return getters.identifyPanel.loading || false;
    },
    identifyLoadingErrorSelector: (state, getters) => {
        return getters.identifyPanel.loadingError;
    },
    identifyMaxItemsSelector: (state, getters) => {
        return getters.identifyPanel.maxItems || 1;
    },
    identifyToleranceSelector: (state, getters) => {
        return getters.identifyPanel.tolerance || 0;
    },
    identifyIndexSelector: (state, getters) => {
        return getters.identifyPanel.index;
    },
    // identifyValidResponsesSelector: (state, getters) => {
    //     getters.identifyRequestsSelector,
    //     getters.identifyResponsesSelector,
    //     getters.identifyGeneralInfoFormatSelector,
    //     (requests, responses, format) => {
    //         //const validatorFormat = getValidator(format);
    //         //return requests.length === responses.length && validatorFormat.getValidResponses(responses);
    //     };
    // },

    // identifyInfoFormatsSelector: (state, getters) => {
    //     return getters.identifyPanel.info_formats || [];
    // },
    // identifyInfoFormatsByMimeTypeSelector: (state, getters) => {
    //     return getters.identifyPanel.info_formats_by_mime_type || [];
    // },
    identifyGeneralInfoFormatSelector: (state, getters) => {
        return getters.identifyPanel.infoFormat || "text/plain";
    },
    identifyRequestsSelector: (state, getters) => {
        return getters.identifyPanel.requests || [];
    },
    identifyResponsesSelector: (state, getters) => {
        return getters.identifyPanel.responses || [];
    },

    // CATALOG
    catalogPanel: (state) => {
        return state.data.panels.catalog;
    },
    catalogSavingSelector: (state, getters) => {
        return getters.catalogPanel.saving || false;
    },
    catalogLoadingSelector: (state, getters) => {
        return getters.catalogPanel.loading || false;
    },
    catalogLoadingErrorSelector: (state, getters) => {
        return getters.catalogPanel.loadingError;
    },
    catalogSearchOptionsSelector: (state, getters) => {
        return getters.catalogPanel.searchOptions || {};
    },
    catalogSearchTextSelector: (state, getters) => {
        return getters.catalogPanel.searchOptions && getters.catalogPanel.searchOptions.text || '';
    },
    catalogDelayAutoSearchSelector: (state, getters) => {
        return getters.catalogPanel.searchOptions && getters.catalogPanel.delayAutoSearch || 1000;
    },
    catalogSelectedServiceSelector: (state, getters) => {
        // return getters.catalogPanel.selectedService;
        const _default = getters.catalogPanel.selectedService;
        const _services = getters.catalogServicesSelector ?? [];
        return _default ?? (_services.length ? _services[0]?.id : null);
    },
    catalogSelectedServiceTypeSelector: (state, getters) => {
        return getters.catalogPanel.services.find(s => s.id == getters.catalogSelectedServiceSelector).type || 'csw';
    },
    catalogSelectedServiceLayerOptionsSelector: (state, getters) => {
        return getters.catalogPanel.services.find(s => s.id == getters.catalogSelectedServiceSelector).layerOptions || {};
    },
    catalogServicesSelector: (state, getters) => {
        return getters.catalogPanel.services;
    },
    catalogSelectedCatalogSelector: (state, getters) => {
        return getters.catalogPanel.services.find(s => s.id == getters.catalogSelectedServiceSelector);
    },
    catalogResultSelector: (state, getters) => {
        return getters.catalogPanel.result;
    },
    catalogPageSizeSelector: (state, getters) => {
        return getters.catalogPanel.pageSize || 4;
    },
    catalogModeSelector: (state, getters) => {
        return getters.catalogPanel.mode || 'view';
    },
    catalogNewServiceSelector: (state, getters) => {
        return getters.catalogPanel.newService;
    },

    // LAYER DOWNLOAD
    layerDownloadPanel: (state) => {
        return state.data.panels.layerdownload;
    },
    layerDownloadLoadingSelector: (state, getters) => {
        return getters.layerDownloadPanel.loading || false;
    },
    layerDownloadWfsFormatsSelector: (state, getters) => {
        return getters.layerDownloadPanel.wfsFormats || [];
    },
    layerDownloadFormatsLoadingSelector: (state, getters) => {
        return getters.layerDownloadPanel.formatsLoading || false;
    },
    layerDownloadDownloadOptionsSelector: (state, getters) => {
        return getters.layerDownloadPanel.downloadOptions || {};
    },

    // FEEDBACK OPTIONS
    feedbackOptionsPanel: (state) => {
        return state.data.panels.feedbackoptions ?? {};
    },
    feedbackOptionsActive: (state, getters) => {
        return getters.feedbackOptionsPanel.active ?? false;
    },
    feedbackOptionsDescription: (state, getters) => {
        return getters.feedbackOptionsPanel.description ?? null;
    },
    feedbackOptionsHelp: (state, getters) => {
        return getters.feedbackOptionsPanel.help ?? null;
    },
    feedbackOptionsTools: (state, getters) => {
        return getters.feedbackOptionsPanel.tools ?? [];
    },
    feedbackOptionsCallback: (state, getters) => {
        return getters.feedbackOptionsPanel.callback ?? null;
    },

    // REGISTER
    registerConfig: (state) => {
        return state.data.global?.settings?.register ?? {};
    },

     // FEATURE VIEWER
     featureViewerPanel: (state) => {
        return state.data.panels.featureviewer;
    },
    featureViewerLoading: (state, getters) => {
        return getters.featureViewerPanel.loading || false;
    },
    featureViewerLoadingError: (state, getters) => {
        return getters.featureViewerPanel.loadingError;
    },
    featureViewerResult: (state, getters) => {
        return getters.featureViewerPanel.result;
    },

    //CkEditor
    ckeditorConfig: (state) => {
        return state.data.global.ckeditor || {};
    },

    //MODULES
    modulesConfig: (state) => {
        return state.data.global.definitions.modules || {};
    },

    // MAP
    getMapDefinitions: (state) => (idModule = null) => {
        return getMapDefinitions(idModule && state[idModule] ? state[idModule] : state);
    },
    getConfigMap: (state) => (idModule = null) => {
        return getConfigMap(idModule && state[idModule] ? state[idModule] : {}, state) || {};
    },
    getActionMap: (state) => (idModule = null) => {
        return getActionMap(idModule && state[idModule] ? state[idModule] : {}, state);
    },
    getViewProjectionMap: (state) => (idModule = null) => {
        return getViewProjectionMap(idModule && state[idModule] ? state[idModule] : state);
    },
    getPrintStyleMap: (state, getters) => (idModule = null) => {
        let config = getters.getConfigMap(idModule) || {};
        config = config.style?.printStyle || {};
        const fill = new Fill({
            color: config?.fillColor || [207, 76, 64, 0.3],
        });
        const stroke = new Stroke({
            color: config?.strokeColor || [128, 128, 128, 1], //'#ccff33', //'#ffcc33'
            width: config?.strokeWidth || 2,
            lineCap: config?.strokeLineCap || 'square',
            lineJoin: config?.strokeLineJoin || 'round',
            lineDash: config?.strokeLineDash || null, //[10, 10],
        });

        let defaultStyles = [
            new Style({
                image: new CircleStyle({
                    fill: fill,
                    stroke: stroke,
                    radius: 7,
                }),
                fill: fill,
                stroke: stroke,
            }),
        ];
        return defaultStyles;
    },
    getDefaultStyleMap: (state, getters) => (idModule = null) => {
        // let config = getters.getConfigMap(idModule) || {};
        // config = config.style?.defaultStyle || {};

        // const fill = new Fill({
        //     color: config?.polygon?.fill?.color ?? config?.fillColor ?? [255, 255, 255, 0.4],
        // });

        // const stroke = new Style({
        //     stroke: new Stroke({
        //         color: config?.line?.stroke?.color ?? config?.strokeColor ?? [0, 144, 184, 1],
        //         width: config?.line?.stroke?.width ?? config?.strokeWidth ?? 2,
        //         lineCap: config?.line?.stroke?.lineCap ?? config?.strokeLineCap ?? 'square',
        //         lineJoin: config?.line?.stroke?.lineJoin ?? config?.strokeLineJoin ?? 'round',
        //     }),
        // });

        // let imageStyle = null
        // if(config?.image?.src) {
        //     imageStyle = new Icon({
        //         color: config?.image?.color ?? undefined,
        //         anchor: config?.image?.anchor ?? [0.5, 0.5],
        //         anchorOrigin: config?.image?.anchorOrigin ?? 'top-left',
        //         anchorXUnits: config?.image?.anchorXUnits ?? 'fraction',
        //         anchorYUnits: config?.image?.anchorYUnits ?? 'fraction',
        //         crossOrigin: config?.image?.crossOrigin ?? 'anonymous',
        //         displacement: config?.image?.displacement ?? [0, 0],
        //         width: config?.image?.width ?? undefined,
        //         height: config?.image?.height ?? undefined,
        //         scale: config?.image?.scale ?? 1,
        //         rotation: config?.image?.rotation ?? 0,
        //         src: config?.image?.src,
        //     });
        // }else{
        //     imageStyle = new CircleStyle({
        //         radius: config?.image?.radius ?? config?.radius ?? 7,
        //         fill: new Fill({
        //             color: config?.image?.fill?.color ?? config?.fillColor ?? blue,
        //         }),
        //         stroke: new Stroke({
        //             color: config?.image?.stroke?.color ?? config?.strokeColor ??[0, 144, 184, 1],
        //             width: config?.image?.stroke?.width ?? config?.strokeWidth ?? 2,
        //             lineCap: config?.image?.stroke?.lineCap ?? config?.strokeLineCap ?? 'square',
        //             lineJoin: config?.image?.stroke?.lineJoin ?? config?.strokeLineJoin ?? 'round',
        //         }),
        //     });
        // }

        // let defaultStyles = [
        //     new Style({
        //         image: imageStyle,
        //         fill: fill,
        //         stroke: stroke,
        //     }),
        // ];

        ////////////////////////
        ////////////////////////
        ////////////////////////
        ////////////////////////

        const styles = {};
        let config = getters.getConfigMap(idModule) || {};
        config = config.style?.defaultStyle || {};
        const white = [255, 255, 255, 1];
        const color = [0, 144, 184, 1];
        const width = 2;
        styles['Polygon'] = [
            new Style({
                fill: new Fill({
                    color: config?.polygon?.fill?.color ?? config?.fillColor ?? [255, 255, 255, 0.4],
                }),
                stroke: new Stroke({
                    color: config?.polygon?.stroke?.color ?? config?.strokeColor ?? color,
                    width: config?.polygon?.stroke?.width ?? config?.strokeWidth ?? width,
                    lineCap: config?.polygon?.stroke?.lineCap ?? config?.strokeLineCap ?? 'square',
                    lineJoin: config?.polygon?.stroke?.lineJoin ?? config?.strokeLineJoin ?? 'round',
                }),
            }),
        ];
        styles['MultiPolygon'] = styles['Polygon'];

        styles['LineString'] = [
             new Style({
                stroke: new Stroke({
                    color: config?.line?.stroke?.colorBack ?? config?.lineStrokeColor ?? white,
                    width: config?.line?.stroke?.widthBack ?? config?.lineStrokeWidth ?? (width + 2),
                    lineCap: config?.line?.stroke?.lineCapBack ?? config?.lineStrokeLineCap ?? 'square',
                    lineJoin: config?.line?.stroke?.lineJoinBack ?? config?.lineStrokeLineJoin ?? 'round',
                }),
            }),
            new Style({
                stroke: new Stroke({
                    color: config?.line?.stroke?.color ?? config?.lineStrokeColor2 ?? color,
                    width: config?.line?.stroke?.width ?? config?.lineStrokeWidth2 ?? width,
                    lineCap: config?.line?.stroke?.lineCap ?? config?.lineStrokeLineCap2 ?? 'square',
                    lineJoin: config?.line?.stroke?.lineJoin ?? config?.lineStrokeLineJoin2 ?? 'round',
                }),
            }),
        ];
        styles['MultiLineString'] = styles['LineString'];

        styles['Circle'] = styles['Polygon'].concat(styles['LineString']);

        if(config?.image?.src) {
            styles['Point'] = [
                new Style({
                    image: new Icon({
                        color: config?.image?.color ?? undefined,
                        anchor: config?.image?.anchor ?? [0.5, 0.5],
                        anchorOrigin: config?.image?.anchorOrigin ?? 'top-left',
                        anchorXUnits: config?.image?.anchorXUnits ?? 'fraction',
                        anchorYUnits: config?.image?.anchorYUnits ?? 'fraction',
                        crossOrigin: config?.image?.crossOrigin ?? 'anonymous',
                        displacement: config?.image?.displacement ?? [0, 0],
                        width: config?.image?.width ?? undefined,
                        height: config?.image?.height ?? undefined,
                        scale: config?.image?.scale ?? 1,
                        rotation: config?.image?.rotation ?? 0,
                        src: config?.image?.src,
                    }),
                    zIndex: Infinity,
                }),
            ];
        }else{
            styles['Point'] = [
                new Style({
                    image: new CircleStyle({
                        radius: config?.image?.radius ?? config?.ptRadius ?? (width * 2),
                        fill: new Fill({
                            color: config?.image?.fill?.color ?? config?.ptFillColor ?? color,
                        }),
                        stroke: new Stroke({
                            color: config?.image?.stroke?.color ?? config?.ptStrokeColor ?? white,
                            width: config?.image?.stroke?.width ?? config?.ptStrokeWidth ?? (width / 2),
                            lineCap: config?.image?.stroke?.lineCap ?? config?.ptStrokeLineCap ?? 'square',
                            lineJoin: config?.image?.stroke?.lineJoin ?? config?.ptStrokeLineJoin ?? 'round',
                        }),
                    }),
                    zIndex: Infinity,
                }),
            ];
        }
        styles['MultiPoint'] = styles['Point'];

        styles['GeometryCollection'] = styles['Polygon']
            .concat(styles['LineString'], styles['Point']);

        return function (feature, resolution) {
            return styles[feature.getGeometry().getType()];
        };
    },
    getEditingStyleMap: (state, getters) => (idModule = null) => {
        const styles = {};
        let config = getters.getConfigMap(idModule) || {};
        config = config.style?.editingStyle || {};
        const white = [255, 255, 255, 1];
        const blue = [0, 153, 255, 1];
        const width = 3;
        styles['Polygon'] = [
            new Style({
                fill: new Fill({
                    color: config?.polygon?.fill?.color ?? config?.fillColor ?? [255, 255, 255, 0.5],
                }),
                stroke: new Stroke({
                    color: config?.polygon?.stroke?.color ?? config?.strokeColor ?? blue,
                    width: config?.polygon?.stroke?.width ?? config?.strokeWidth ?? width,
                    lineCap: config?.polygon?.stroke?.lineCap ?? config?.strokeLineCap ?? 'square',
                    lineJoin: config?.polygon?.stroke?.lineJoin ?? config?.strokeLineJoin ?? 'round',
                }),
            }),
        ];
        styles['MultiPolygon'] = styles['Polygon'];

        styles['LineString'] = [
            new Style({
                stroke: new Stroke({
                    color: config?.line?.stroke?.colorBack ?? config?.lineStrokeColor ?? white,
                    width: config?.line?.stroke?.widthBack ?? config?.lineStrokeWidth ?? (width + 2),
                    lineCap: config?.line?.stroke?.lineCapBack ?? config?.lineStrokeLineCap ?? 'square',
                    lineJoin: config?.line?.stroke?.lineJoinBack ?? config?.lineStrokeLineJoin ?? 'round',
                }),
            }),
            new Style({
                stroke: new Stroke({
                    color: config?.line?.stroke?.color ?? config?.lineStrokeColor2 ?? blue,
                    width: config?.line?.stroke?.width ?? config?.lineStrokeWidth2 ?? width,
                    lineCap: config?.line?.stroke?.lineCap ?? config?.lineStrokeLineCap2 ?? 'square',
                    lineJoin: config?.line?.stroke?.lineJoin ?? config?.lineStrokeLineJoin2 ?? 'round',
                }),
            }),
        ];
        styles['MultiLineString'] = styles['LineString'];

        styles['Circle'] = styles['Polygon'].concat(styles['LineString']);

        if(config?.image?.src) {
            styles['Point'] = [
                new Style({
                    image: new Icon({
                        color: config?.image?.color ?? undefined,
                        anchor: config?.image?.anchor ?? [0.5, 0.5],
                        anchorOrigin: config?.image?.anchorOrigin ?? 'top-left',
                        anchorXUnits: config?.image?.anchorXUnits ?? 'fraction',
                        anchorYUnits: config?.image?.anchorYUnits ?? 'fraction',
                        crossOrigin: config?.image?.crossOrigin ?? 'anonymous',
                        displacement: config?.image?.displacement ?? [0, 0],
                        width: config?.image?.width ?? undefined,
                        height: config?.image?.height ?? undefined,
                        scale: config?.image?.scale ?? 1,
                        rotation: config?.image?.rotation ?? 0,
                        src: config?.image?.src,
                    }),
                    zIndex: Infinity,
                }),
            ];
        }else{
            styles['Point'] = [
                new Style({
                    image: new CircleStyle({
                        radius: config?.image?.radius ?? config?.ptRadius ?? (width * 2),
                        fill: new Fill({
                            color: config?.image?.fill?.color ?? config?.ptFillColor ?? blue,
                        }),
                        stroke: new Stroke({
                            color: config?.image?.stroke?.color ?? config?.ptStrokeColor ?? white,
                            width: config?.image?.stroke?.width ?? config?.ptStrokeWidth ?? (width / 2),
                            lineCap: config?.image?.stroke?.lineCap ?? config?.ptStrokeLineCap ?? 'square',
                            lineJoin: config?.image?.stroke?.lineJoin ?? config?.ptStrokeLineJoin ?? 'round',
                        }),
                    }),
                    zIndex: Infinity,
                }),
            ];
        }
        styles['MultiPoint'] = styles['Point'];

        styles['GeometryCollection'] = styles['Polygon']
            .concat(styles['LineString'], styles['Point']);

        return function (feature, resolution) {
            return styles[feature.getGeometry().getType()];
        };
    },

    // BROADCASTING
    broadcastingEnabled: (state) => {
        return state.data.global.broadcasting.active ?? false;
    },
    broadcastingState: (state) => {
        return state.data.global.broadcasting.state ?? null;
    },

    getAction: (state) => (idModule = null) => {
        return getAction(idModule && state[idModule] ? state[idModule] : state) ?? null;
    },
};